import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

const DSN = process.env.SENTRY_DSN || ''

if (DSN != '') {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.NODE_ENV,
    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    release: "qonto-homepage@2.3.12",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.01,
    // Send a representative sample of our errors to Sentry.
    // https://docs.sentry.io/platforms/javascript/configuration/sampling/
    sampleRate: 0.1,
    // Disable Session Health feature
    // https://docs.sentry.io/platforms/javascript/configuration/options/#auto-session-tracking
    autoSessionTracking: false,

  });
}
